var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNum3White(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 170.69 229.18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M82.29,229.18c-13.83,0-25.84-1.53-36.04-4.59s-18.65-7.48-25.33-13.26c-6.69-5.78-11.73-12.75-15.13-20.91-3.4-8.16-5.33-17.11-5.78-26.86l28.9-8.16c.22,9.52,1.92,17.34,5.1,23.46,3.17,6.12,7.42,10.94,12.75,14.45,5.32,3.52,11.1,6.01,17.34,7.48,6.23,1.48,12.41,2.21,18.53,2.21,10.42,0,19.95-1.41,28.56-4.25,8.61-2.83,15.47-7.42,20.57-13.77,5.1-6.34,7.65-14.62,7.65-24.82,0-12.69-3.8-22.67-11.39-29.92-7.6-7.25-18.25-12.29-31.96-15.13-13.72-2.83-29.98-3.91-48.79-3.23v-20.74L126.15,28.56v-2.38l-117.31.34V0h148.93v32.98l-73.45,59.17v2.38c20.85,0,37.57,2.84,50.15,8.5,12.58,5.67,21.76,13.43,27.54,23.29,5.78,9.86,8.67,21.14,8.67,33.83,0,13.83-3.29,25.96-9.86,36.38-6.58,10.43-16.38,18.48-29.41,24.14-13.04,5.66-29.41,8.5-49.13,8.5Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNum3White);
export default __webpack_public_path__ + "static/media/num_3_white.2e148b5cd3d1dcbc9820360ea244ee51.svg";
export { ForwardRef as ReactComponent };